import { Spacing } from '@persona-id/design-tokens';
import styled from 'styled-components';

export const SectionInputWrapper = styled.div`
  & + & {
    margin-top: ${Spacing[3]};
  }
`;

export const SingleInputWrapper = styled.div`
  margin-top: ${Spacing[3]};
`;

export const SectionRow = styled.div`
  display: flex;
  align-items: 'end';
  gap: ${Spacing[3]};
  & + & {
    margin-top: ${Spacing[3]};
  }
`;

export const SectionColumn = styled.div`
  flex: 1;
`;
